import React from 'react';

import LinkButton from '_components/LinkButton';
import sunnyTrustBanner from '_images/sunnytrust-banner.png';

interface Props {
  lite?: boolean;
}

const SunnyTrust = ({lite = false}: Props) => (
  <div className="relative">
    {!lite && (
      <div className="hidden lg:block w-[124px] h-[124px] rounded-full bg-primary absolute left-[-62px] top-1/2 -translate-y-1/2"></div>
    )}
    <div className="hidden lg:block max-w-[474px] h-full mx-auto lg:mx-0 absolute right-0 top-0">
      <img
        src={sunnyTrustBanner}
        className="w-full h-full object-cover"
        alt="Sunnytrust Banner"
      />
    </div>
    <div className="py-12 lg:py-20 max-w-section mx-auto flex flex-col lg:flex-row items-center h-full">
      <div className="px-4 lg:pl-32 lg:pr-0 order-2 lg:order-1 text-center lg:text-left relative flex-1 max-w-[768px]">
        <div className="mt-3 text-gray1">protect yourself with</div>
        <div className="mt-2 uppercase font-bely text-5xl lg:text-8xl text-primary">
          Sunnytrust
        </div>
        <div className="mt-4 text-gray1 lg:text-lg">
          SunnyTrust can protect you and your investment. A comprehensive
          guarantee and protection will be given to you as you embark with us
          for all your renovation services. From start to finish, we'll ensure
          your project is completed to the highest standards, giving you the
          confidence and assurance you deserve. Contact us today to have a
          worry-free renovation journey with SunnyTrust by Sunnyside.
        </div>
        {!lite && (
          <div className="mt-6 lg:mt-12">
            <LinkButton to="/sunny-trust" color="blue" className="w-[230px]">
              Learn more
            </LinkButton>
          </div>
        )}
      </div>
    </div>
  </div>
);

export default SunnyTrust;
